import gravatarUrl from "gravatar-url";
import React from "react";
import { useDrag } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import {
  controlConfirmationDialog,
  setIdToBeDeleted,
} from "../../features/projects/projectSlice";

export default function TeamCard({ work, plus, setItem }) {
  //Dispatcher
  const dispatch = useDispatch();

  //Destructuring work
  let { id, creator, teamName, teamColor, description, date } = work;

  //converts milliseconds to Date
  date = new Date(date).toDateString();

  const searchedValue = useSelector((state) => state.projects.search);

  const [{ isDragging }, drag] = useDrag(() => ({
    type: "WORK",
    item: { ...work },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const hadnleDeleted = (id) => {
    dispatch(controlConfirmationDialog());
    dispatch(setIdToBeDeleted(id));
  };
  return (
    <div className="relative">
      {description.includes(searchedValue) && searchedValue !== "" && (
        <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-purple-500 roundede-lg blur opacity-50 rounded-lg"></div>
      )}
      {isDragging ? (
        <div className="relative flex flex-col items-start p-14 m-2 rounded-lg bg-transparent border-2 border-dashed border-black"></div>
      ) : (
        <div
          className="relative flex flex-col items-start p-4 m-2 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
          ref={drag}
        >
          {plus && (
            <button
              className="absolute top-0 right-0 flex items-center justify-center hidden w-4 h-5 mt-3 mr-5 text-gray-500 rounded hover:bg-gray-200 hover:text-gray-700 group-hover:flex"
              onClick={() => hadnleDeleted(id)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
              </svg>
            </button>
          )}
          <span
            className={`flex items-center h-6 px-3 text-xs font-semibold rounded-full`}
            style={{
              backgroundColor: `${teamColor}`,
              color: "white",
            }}
          >
            {teamName}
          </span>
          <h4 className="mt-3 text-sm font-medium">{description}</h4>

          <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
            <div className="flex items-center">
              <svg
                className="w-4 h-4 text-gray-300 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="ml-1 leading-none">{date}</span>
            </div>

            <img
              className="w-6 h-6 ml-auto rounded-full"
              src={gravatarUrl(creator, {
                size: 80,
              })}
              alt="creator"
            />
          </div>
        </div>
      )}
    </div>
  );
}
